import React from 'react';
import { remCss, scssVariables as variables } from 'src/helpers';

const GeneralMedicineIcon = React.memo(({ width = 81, height = 80, viewBox = '0 0 81 80' }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={remCss(width)}
    height={remCss(height)}
    viewBox={viewBox}
  >
    <path
      fill={variables['colors-mc-primary']}
      fillOpacity='0.1'
      stroke={variables['colors-mc-primary']}
      d='M79.9282 40C79.9282 61.8153 62.2435 79.5 40.4282 79.5C18.613 79.5 0.928223 61.8153 0.928223 40C0.928223 18.1848 18.613 0.5 40.4282 0.5C62.2435 0.5 79.9282 18.1848 79.9282 40Z'
    />
    <path
      d='M20.6663 28.1472C19.4459 29.3676 19.4459 31.3462 20.6663 32.5666C21.8867 33.787 23.8653 33.787 25.0857 32.5666L27.2954 30.3569L25.9739 26.7591L22.876 25.9375L20.6663 28.1472Z'
      fill='#FFC344'
    />
    <path
      d='M52.564 21.6692C51.0693 22.5322 50.5572 24.4434 51.4201 25.9381L52.9826 28.6444H56.3598L58.3953 25.5194L56.8328 22.8131C55.9698 21.3183 54.0586 20.8062 52.564 21.6692Z'
      fill='#FFC344'
    />
    <path
      d='M48.4859 65H31.6411C30.2521 65 29.126 63.8739 29.126 62.4849V60.3125L32.251 52.5L29.126 44.6875V44.5835C29.126 43.6496 29.497 42.754 30.1573 42.0937L35.3761 36.875L40.0636 35.3125L44.7511 36.875L49.9697 42.0937C50.6301 42.754 51.0011 43.6496 51.0011 44.5835V62.4849C51.0011 63.8739 49.875 65 48.4859 65Z'
      fill='#DCF5F8'
    />
    <path
      d='M49.9696 42.0936L44.751 36.875L41.7329 35.8689L45.1996 39.3356C46.3376 40.4736 46.9769 42.0169 46.9769 43.6263V57.9259C46.9769 60.7215 44.7105 62.9878 41.9149 62.9878H29.1763C29.4093 64.1359 30.4242 65 31.641 65H48.4858C49.8749 65 51.001 63.8739 51.001 62.4848V44.5834C51.001 43.6496 50.63 42.754 49.9696 42.0936Z'
      fill='#A6E7F0'
    />
    <path
      d='M41.6794 60.3125H29.126V44.741H41.6794C42.5128 44.741 43.1885 45.4166 43.1885 46.25V58.8035C43.1885 59.637 42.5128 60.3125 41.6794 60.3125Z'
      fill='#80D261'
    />
    <path
      d='M39.8193 50.9375H37.9639C37.829 50.9375 37.7197 50.8282 37.7197 50.6934V48.8379C37.7197 48.703 37.6104 48.5938 37.4756 48.5938H34.8389C34.704 48.5938 34.5947 48.703 34.5947 48.8379V50.6934C34.5947 50.8282 34.4854 50.9375 34.3506 50.9375H32.4951C32.3603 50.9375 32.251 51.0468 32.251 51.1816V53.8184C32.251 53.9532 32.3603 54.0625 32.4951 54.0625H34.3506C34.4854 54.0625 34.5947 54.1718 34.5947 54.3066V56.1621C34.5947 56.297 34.704 56.4062 34.8389 56.4062H37.4756C37.6104 56.4062 37.7197 56.297 37.7197 56.1621V54.3066C37.7197 54.1718 37.829 54.0625 37.9639 54.0625H39.8193C39.9542 54.0625 40.0635 53.9532 40.0635 53.8184V51.1816C40.0635 51.0468 39.9541 50.9375 39.8193 50.9375Z'
      fill='#EAF9FA'
    />
    <path
      d='M45.3075 36.875H34.8195C34.2639 36.875 33.8135 36.4246 33.8135 35.8689V30.0686C33.8135 29.5129 34.2639 29.0625 34.8195 29.0625H45.3074C45.8631 29.0625 46.3135 29.5129 46.3135 30.0686V35.8689C46.3136 36.4246 45.8631 36.875 45.3075 36.875Z'
      fill='#02C7DD'
    />
    <path
      d='M45.0292 18.125H42.6587C42.5198 18.125 42.4072 18.0124 42.4072 17.8735V15.503C42.4072 15.2252 42.182 15 41.9042 15H38.2228C37.9449 15 37.7197 15.2252 37.7197 15.503V17.8735C37.7197 18.0124 37.6071 18.125 37.4683 18.125H35.0978C34.8199 18.125 34.5947 18.3502 34.5947 18.628V22.3095C34.5947 22.5873 34.8199 22.8125 35.0978 22.8125H37.4683C37.6071 22.8125 37.7197 22.9251 37.7197 23.064V25.4345C37.7197 25.7123 37.9449 25.9375 38.2228 25.9375H41.9042C42.182 25.9375 42.4072 25.7123 42.4072 25.4345V23.064C42.4072 22.9251 42.5198 22.8125 42.6587 22.8125H45.0292C45.307 22.8125 45.5322 22.5873 45.5322 22.3095V18.628C45.5322 18.3502 45.3069 18.125 45.0292 18.125Z'
      fill='#80D261'
    />
    <path
      d='M54.5449 31.3506C55.4079 32.8453 57.3191 33.3574 58.8138 32.4945C60.3084 31.6315 60.8205 29.7203 59.9576 28.2256L58.3951 25.5193L52.9824 28.6443L54.5449 31.3506Z'
      fill='#80D261'
    />
    <path
      d='M29.5051 23.7278C28.2847 22.5074 26.3061 22.5074 25.0856 23.7278L22.876 25.9375L27.2954 30.3569L29.5051 28.1472C30.7255 26.9268 30.7255 24.9481 29.5051 23.7278Z'
      fill='#02C7DD'
    />
    <path
      d='M24.4385 47.8125C24.4385 49.2861 23.4185 50.5216 22.0459 50.8511C21.8109 50.9076 21.5657 50.1623 21.3135 50.1623C21.0612 50.1623 20.816 50.9076 20.5811 50.8511C19.2085 50.5216 18.1885 49.2861 18.1885 47.8125C18.1885 46.3388 19.2085 45.1034 20.5811 44.7738C20.816 44.7174 21.0612 45.4627 21.3135 45.4627C21.5657 45.4627 21.8109 44.7174 22.0459 44.7738C23.4184 45.1034 24.4385 46.3388 24.4385 47.8125Z'
      fill='#FFE177'
    />
    <path
      d='M59.4606 50.0221C58.4186 51.0641 56.8238 51.2165 55.6202 50.4791C55.4142 50.3528 55.6116 49.6555 55.4333 49.4772C55.255 49.2989 54.7106 49.6493 54.5844 49.4432C53.847 48.2396 53.9992 46.6448 55.0413 45.6028C56.0834 44.5608 57.6781 44.4085 58.8817 45.1459C59.0878 45.2721 58.7009 46.0268 58.8793 46.2052C59.0318 46.3578 59.7468 45.9197 59.8611 46.093C60.662 47.3059 60.5285 48.9544 59.4606 50.0221Z'
      fill='#F9B1B1'
    />
    <path
      d='M53.3447 40C54.6391 40 55.6885 38.9507 55.6885 37.6562C55.6885 36.3618 54.6391 35.3125 53.3447 35.3125C52.0503 35.3125 51.001 36.3618 51.001 37.6562C51.001 38.9507 52.0503 40 53.3447 40Z'
      fill='#FFC344'
    />
    <path
      d='M20.5322 41.5625C21.8266 41.5625 22.876 40.5132 22.876 39.2188C22.876 37.9243 21.8266 36.875 20.5322 36.875C19.2378 36.875 18.1885 37.9243 18.1885 39.2188C18.1885 40.5132 19.2378 41.5625 20.5322 41.5625Z'
      fill='#02C7DD'
    />
    <path
      d='M43.1885 33.0176C42.784 33.0176 42.4561 33.3455 42.4561 33.75V36.875H43.9209V33.75C43.9209 33.3455 43.593 33.0176 43.1885 33.0176Z'
      fill='#07B2CD'
    />
    <path
      d='M40.0635 33.0176C39.659 33.0176 39.3311 33.3455 39.3311 33.75V36.875H40.7959V33.75C40.7959 33.3455 40.468 33.0176 40.0635 33.0176Z'
      fill='#07B2CD'
    />
    <path
      d='M36.9385 33.0176C36.534 33.0176 36.2061 33.3455 36.2061 33.75V36.875H37.6709V33.75C37.6709 33.3455 37.343 33.0176 36.9385 33.0176Z'
      fill='#07B2CD'
    />
    <path
      d='M43.1885 40.7324H36.9385C36.534 40.7324 36.2061 40.4045 36.2061 40C36.2061 39.5955 36.534 39.2676 36.9385 39.2676H43.1885C43.5931 39.2676 43.9209 39.5955 43.9209 40C43.9209 40.4045 43.593 40.7324 43.1885 40.7324Z'
      fill='#A6E7F0'
    />
    <path
      d='M29.1259 36.1455H28.2928V35.3124C28.2928 34.9096 27.9662 34.583 27.5634 34.583C27.1605 34.583 26.834 34.9096 26.834 35.3124V36.1455H26.0009C25.598 36.1455 25.2715 36.4721 25.2715 36.8749C25.2715 37.2777 25.598 37.6043 26.0009 37.6043H26.834V38.4374C26.834 38.8402 27.1605 39.1668 27.5634 39.1668C27.9662 39.1668 28.2928 38.8402 28.2928 38.4374V37.6043H29.1259C29.5287 37.6043 29.8553 37.2777 29.8553 36.8749C29.8553 36.4721 29.5286 36.1455 29.1259 36.1455Z'
      fill='#80D261'
    />
    <path
      d='M61.9385 39.2705H61.1053V38.4374C61.1053 38.0346 60.7788 37.708 60.3759 37.708C59.973 37.708 59.6465 38.0346 59.6465 38.4374V39.2705H58.8134C58.4105 39.2705 58.084 39.5971 58.084 39.9999C58.084 40.4027 58.4105 40.7293 58.8134 40.7293H59.6465V41.5624C59.6465 41.9652 59.973 42.2918 60.3759 42.2918C60.7788 42.2918 61.1053 41.9652 61.1053 41.5624V40.7293H61.9385C62.3413 40.7293 62.6679 40.4027 62.6679 39.9999C62.6678 39.5971 62.3413 39.2705 61.9385 39.2705Z'
      fill='#80D261'
    />
    <path
      d='M20.5811 44.7738V50.8511C20.816 50.9075 21.0612 50.9374 21.3135 50.9374C21.5657 50.9374 21.8109 50.9074 22.0459 50.8511V44.7738C21.8109 44.7174 21.5657 44.6875 21.3135 44.6875C21.0612 44.6875 20.8159 44.7175 20.5811 44.7738Z'
      fill='#FFD15B'
    />
    <path
      d='M59.4607 45.6028C59.2824 45.4245 59.0878 45.2723 58.8817 45.146L54.5845 49.4433C54.7107 49.6493 54.863 49.8438 55.0413 50.0223C55.2196 50.2007 55.4143 50.3528 55.6203 50.4791L59.9176 46.1818C59.7914 45.9758 59.6391 45.7812 59.4607 45.6028Z'
      fill='#F79595'
    />
  </svg>
));
GeneralMedicineIcon.displayName = 'GeneralMedicineIcon';

export default GeneralMedicineIcon;
